module.exports = __webpack_public_path__ + "img/solution22.b2064eb0.png";